// extracted by mini-css-extract-plugin
export default {"fadeInElement":"TextAnimation_fadeInElement__-YMzI","fadeIn":"TextAnimation_fadeIn__eHhS4"};